import * as loader from 'shared/operators/loader';
import * as React from 'react';

import { IStateBase } from './BaseComponent';

interface IState extends IStateBase {
  refs: number[];
}

let timeout: any = null;

const element = document.getElementById('loader');

export default class LoaderComponent extends React.Component<{}, IState> {
  constructor(props: any) {
    super(props);

    loader.setup(this);
    this.state = { refs: [] };
  }

  public show(ref: number): void {
    if (typeof ref !== 'number') {
      throw new Error('Loader.show needs a ref number value');
    }

    const { refs } = this.state;
    if (refs.some(r => r === ref)) return;

    refs.push(ref);
    this.setState({ refs });
  }

  public hide(ref: number): void {
    if (typeof ref !== 'number') {
      throw new Error('Loader.hide needs a ref number value');
    }

    const { refs } = this.state;
    const index = refs.indexOf(ref);

    if (index === -1) {
      return;
    }

    refs.splice(index, 1);
    this.setState({ refs });
  }

  componentDidMount() {
    if (!element) {
      return;
    }

    setTimeout(
      () => {
        const className = element.className || '';

        element.className = className.replace('starting', '');
        console.log('removed starting loader class');
      },
      window.CACHED_MOUNT ? 3000 : 0
    );
  }

  render(): any {
    const { refs } = this.state;

    if (!element) {
      return;
    }

    clearTimeout(timeout);

    timeout = setTimeout(() => {
      const className = (element.className || '').replace('hide', '');

      if (refs.length == 0) {
        element.className = `${className} hide`;
      } else {
        element.className = className;
      }
    }, 150);

    return null;
  }
}
